/* Confirmed-success attribution and Google Ads tracking for space-rental inquiries. */
(function () {
  'use strict';

  if (window.__bbSpaceRentalTrackingLoaded) return;
  window.__bbSpaceRentalTrackingLoaded = true;

  var SUCCESS_MARKER = 'space_rental_inquiry';
  var DESTINATION_PATH = '/pages/space-rental-2026';
  var GOOGLE_TAG_ID = 'AW-11501161583';
  var GOOGLE_SEND_TO = 'AW-11501161583/d9ZZCLHntOIcEO-Yl-wq';
  var LEAD_VALUE = 250;
  var MAX_DELIVERY_ATTEMPTS = 10;
  var RETRY_DELAY_MS = 500;
  var GOOGLE_ACK_TIMEOUT_MS = 3500;
  var SUCCESS_URL_CLEANUP_DELAY_MS = 5000;
  var ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid'
  ];
  var ATTRIBUTION_SESSION_KEY = 'bb:space-rental:attribution';
  var deliveryStates = window.__bbSpaceRentalDeliveryStates || {};
  window.__bbSpaceRentalDeliveryStates = deliveryStates;

  function safeStorage(kind) {
    try { return window[kind]; } catch (_error) { return null; }
  }

  function getItem(store, key) {
    try { return store ? store.getItem(key) : null; } catch (_error) { return null; }
  }

  function setItem(store, key, value) {
    try { if (store) store.setItem(key, value); } catch (_error) {}
  }

  function removeItem(store, key) {
    try { if (store) store.removeItem(key); } catch (_error) {}
  }

  function hasFlag(session, durable, key) {
    return getItem(session, key) === '1' || getItem(durable, key) === '1';
  }

  function setFlag(session, durable, key) {
    setItem(session, key, '1');
    setItem(durable, key, '1');
  }

  function makeId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return prefix + '_' + window.crypto.randomUUID();
    }
    return prefix + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
  }

  function parseJson(value) {
    try {
      var parsed = JSON.parse(value || '{}');
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (_error) {
      return {};
    }
  }

  /* Last non-direct touch: a new tagged URL replaces the prior touch atomically,
     so an old click ID can never leak into a different campaign's attribution. */
  function collectAttribution(params, session) {
    var current = {};
    var hasCurrentTouch = false;
    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      current[key] = value.slice(0, 255);
      hasCurrentTouch = true;
    });

    var stored = parseJson(getItem(session, ATTRIBUTION_SESSION_KEY));
    var values = hasCurrentTouch ? current : {};
    if (!hasCurrentTouch) {
      ATTRIBUTION_KEYS.forEach(function (key) {
        if (typeof stored[key] === 'string' && stored[key]) {
          values[key] = stored[key].slice(0, 255);
        }
      });
    }
    setItem(session, ATTRIBUTION_SESSION_KEY, JSON.stringify(values));
    return values;
  }

  function setField(form, selector, value) {
    var field = form.querySelector(selector);
    if (field) field.value = value || '';
  }

  function ensureHidden(form, name, selector, attributes) {
    var field = selector ? form.querySelector(selector) : null;
    if (!field) {
      var namedFields = form.querySelectorAll('input[name="' + name + '"]');
      field = namedFields.length ? namedFields[0] : null;
    }
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      Object.keys(attributes || {}).forEach(function (attribute) {
        field.setAttribute(attribute, attributes[attribute]);
      });
      form.appendChild(field);
    }
    return field;
  }

  function ensureTrackingFields(form) {
    ensureHidden(form, 'return_to');
    ensureHidden(form, 'contact[Inquiry source]', '[data-sr2-source]', { 'data-sr2-source': '' });
    ensureHidden(form, 'contact[Landing page]', '[data-sr2-landing-page]', { 'data-sr2-landing-page': '' });
    ensureHidden(form, 'contact[Lead ID]', '[data-sr2-lead-id]', { 'data-sr2-lead-id': '' });
    ensureHidden(form, 'contact[Event ID]', '[data-sr2-event-id]', { 'data-sr2-event-id': '' });
    ATTRIBUTION_KEYS.forEach(function (key) {
      ensureHidden(
        form,
        'contact[' + key + ']',
        '[data-sr2-attribution="' + key + '"]',
        { 'data-sr2-attribution': key }
      );
    });
  }

  function setReturnTo(form, value) {
    Array.prototype.forEach.call(form.querySelectorAll('input[name="return_to"]'), function (field) {
      field.value = value;
    });
  }

  function processingPermission(method) {
    try {
      if (
        !window.Shopify ||
        !window.Shopify.customerPrivacy ||
        typeof window.Shopify.customerPrivacy[method] !== 'function'
      ) return null;
      return window.Shopify.customerPrivacy[method]() === true;
    } catch (_error) {
      return null;
    }
  }

  function wakeDeliveryStates() {
    Object.keys(deliveryStates).forEach(function (eventId) {
      var state = deliveryStates[eventId];
      if (state && typeof state.wake === 'function') state.wake();
    });
  }

  function ensureGoogleTag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (document.querySelector('script[data-bb-space-rental-google-tag]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GOOGLE_TAG_ID);
    script.setAttribute('data-bb-space-rental-google-tag', '1');
    if (typeof script.addEventListener === 'function') {
      script.addEventListener('load', wakeDeliveryStates);
    }
    document.head.appendChild(script);
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_TAG_ID, { allow_ad_personalization_signals: false });
  }

  function acquisitionChannel(attribution) {
    if (attribution.gclid || attribution.gbraid || attribution.wbraid) return 'paid_search';
    if (attribution.utm_source === 'google' && attribution.utm_medium === 'cpc') return 'paid_search';
    if (attribution.utm_source || attribution.utm_medium) return 'tagged_campaign';
    return 'direct_or_unattributed';
  }

  function prepareForm(form, params) {
    if (!form || form.dataset.sr2TrackingInit === '1') return;
    form.dataset.sr2TrackingInit = '1';
    ensureTrackingFields(form);

    var session = safeStorage('sessionStorage');
    var durable = safeStorage('localStorage');
    var attribution = collectAttribution(params, session);
    var leadId = makeId('bbsr_lead');
    var eventId = makeId('bbsr_event');

    setField(form, '[data-sr2-source]', 'Owned website - space rental');
    setField(form, '[data-sr2-landing-page]', window.location.href.slice(0, 1000));
    setField(form, '[data-sr2-lead-id]', leadId);
    setField(form, '[data-sr2-event-id]', eventId);
    ATTRIBUTION_KEYS.forEach(function (key) {
      setField(form, '[data-sr2-attribution="' + key + '"]', attribution[key] || '');
    });

    var requestedPath = form.dataset.sr2Destination;
    var destination = requestedPath && /^\/pages\/[a-z0-9-]+$/.test(requestedPath) ? requestedPath : DESTINATION_PATH;
    var returnTo = new URL(destination, window.location.origin);
    if (requestedPath && window.Shopify && window.Shopify.theme &&
        (params.has('preview_theme_id') || document.querySelector('#OnlineStorePreviewBarNextData'))) {
      returnTo.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    }
    returnTo.searchParams.set('contact_posted', 'true');
    returnTo.searchParams.set('bb_lead', SUCCESS_MARKER);
    returnTo.searchParams.set('lead_id', leadId);
    returnTo.searchParams.set('event_id', eventId);
    ATTRIBUTION_KEYS.forEach(function (key) {
      if (attribution[key]) returnTo.searchParams.set(key, attribution[key]);
    });
    setReturnTo(form, returnTo.pathname + returnTo.search + '#sr2-inquiry');

    form.addEventListener('submit', function () {
      /* Keep only the proof needed to match the server-rendered success page.
         A localStorage copy makes the match survive restrictive session storage. */
      var pending = {
        lead_id: leadId,
        event_id: eventId,
        occurred_at_ms: Date.now(),
        acquisition_channel: acquisitionChannel(attribution)
      };
      var pendingValue = JSON.stringify(pending);
      var pendingKey = 'bb:space-rental:pending:' + eventId;
      setItem(session, pendingKey, pendingValue);
      setItem(durable, pendingKey, pendingValue);
    });

    if (processingPermission('marketingAllowed') === true) ensureGoogleTag();
  }

  function cleanupSuccessUrl(params, state) {
    if (state && state.cleanupScheduled) return;
    if (state) state.cleanupScheduled = true;
    window.setTimeout(function () {
      ['contact_posted', 'bb_lead', 'lead_id', 'event_id'].forEach(function (key) {
        params.delete(key);
      });
      var query = params.toString();
      window.history.replaceState(
        {},
        '',
        (window.location.pathname || DESTINATION_PATH) + (query ? '?' + query : '') + '#sr2-inquiry'
      );
    }, SUCCESS_URL_CLEANUP_DELAY_MS);
  }

  function trackSuccess(root, params) {
    var successMessage = root.querySelector('[data-sr2-success]') || root.querySelector('.form-confirm');
    if (
      !successMessage ||
      params.get('contact_posted') !== 'true' ||
      params.get('bb_lead') !== SUCCESS_MARKER
    ) return false;

    var leadId = params.get('lead_id') || '';
    var eventId = params.get('event_id') || '';
    if (!leadId || !eventId) return true;

    var session = safeStorage('sessionStorage');
    var durable = safeStorage('localStorage');
    var pendingKey = 'bb:space-rental:pending:' + eventId;
    var trackedKey = 'bb:space-rental:tracked:' + eventId;
    var adsDeliveredKey = trackedKey + ':google';
    var adsSkippedKey = trackedKey + ':google-consent-skipped';
    var analyticsDeliveredKey = trackedKey + ':analytics';
    var analyticsSkippedKey = trackedKey + ':analytics-consent-skipped';

    /* A completed event may have removed its pending proof before a refresh. */
    if (hasFlag(session, durable, trackedKey)) {
      removeItem(session, pendingKey);
      removeItem(durable, pendingKey);
      cleanupSuccessUrl(params, null);
      return true;
    }

    var pending = parseJson(getItem(session, pendingKey) || getItem(durable, pendingKey));
    if (pending.lead_id !== leadId || pending.event_id !== eventId) return true;

    var existingState = deliveryStates[eventId];
    if (existingState && !existingState.settled) {
      existingState.params = params;
      existingState.wake();
      return true;
    }

    var state = {
      leadId: leadId,
      eventId: eventId,
      pending: pending,
      params: params,
      session: session,
      durable: durable,
      pendingKey: pendingKey,
      trackedKey: trackedKey,
      adsDeliveredKey: adsDeliveredKey,
      adsSkippedKey: adsSkippedKey,
      analyticsDeliveredKey: analyticsDeliveredKey,
      analyticsSkippedKey: analyticsSkippedKey,
      adsTerminal: hasFlag(session, durable, adsDeliveredKey) || hasFlag(session, durable, adsSkippedKey),
      analyticsTerminal: hasFlag(session, durable, analyticsDeliveredKey) || hasFlag(session, durable, analyticsSkippedKey),
      adsInFlight: false,
      adsAckTimer: null,
      retryTimer: null,
      attempts: 0,
      settled: false,
      cleanupScheduled: false,
      wake: null
    };
    deliveryStates[eventId] = state;

    function clearAdsAckTimer() {
      if (state.adsAckTimer !== null) {
        window.clearTimeout(state.adsAckTimer);
        state.adsAckTimer = null;
      }
    }

    function finishIfSettled() {
      if (state.settled || !state.adsTerminal || !state.analyticsTerminal) return false;
      state.settled = true;
      state.adsInFlight = false;
      clearAdsAckTimer();
      if (state.retryTimer !== null) {
        window.clearTimeout(state.retryTimer);
        state.retryTimer = null;
      }
      setFlag(session, durable, trackedKey);
      removeItem(session, pendingKey);
      removeItem(durable, pendingKey);
      cleanupSuccessUrl(state.params, state);
      return true;
    }

    function scheduleRetry() {
      if (
        state.settled ||
        state.retryTimer !== null ||
        state.adsInFlight ||
        state.attempts >= MAX_DELIVERY_ATTEMPTS
      ) return;
      state.retryTimer = window.setTimeout(attemptDelivery, RETRY_DELAY_MS);
    }

    function markAdsDelivered() {
      if (state.adsTerminal) return;
      state.adsInFlight = false;
      clearAdsAckTimer();
      state.adsTerminal = true;
      setFlag(session, durable, adsDeliveredKey);
      if (!finishIfSettled()) scheduleRetry();
    }

    function markAdsConsentSkipped() {
      if (state.adsTerminal) return;
      state.adsInFlight = false;
      clearAdsAckTimer();
      state.adsTerminal = true;
      setFlag(session, durable, adsSkippedKey);
    }

    function markAnalyticsConsentSkipped() {
      if (state.analyticsTerminal) return;
      state.analyticsTerminal = true;
      setFlag(session, durable, analyticsSkippedKey);
    }

    function publishAnalyticsSuccess() {
      if (state.analyticsTerminal) return;
      window.dataLayer = window.dataLayer || [];
      try {
        window.dataLayer.push({
          event: 'bb_space_rental_inquiry_success',
          form_name: SUCCESS_MARKER,
          lead_id: leadId,
          event_id: eventId,
          acquisition_channel: pending.acquisition_channel
        });
      } catch (_error) {
        return;
      }
      /* Shopify custom-event publication is best-effort after the durable local
         event enqueue; pixel subscribers apply their own consent requirements. */
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        try {
          window.Shopify.analytics.publish('bloom_boom:space_rental_inquiry_success', {
            lead_id: leadId,
            event_id: eventId,
            acquisition_channel: pending.acquisition_channel
          });
        } catch (_error) {}
      }
      state.analyticsTerminal = true;
      setFlag(session, durable, analyticsDeliveredKey);
    }

    function sendGoogleConversion() {
      if (state.adsTerminal || state.adsInFlight) return;
      ensureGoogleTag();
      state.adsInFlight = true;
      var callbackRan = false;
      function acknowledge() {
        if (callbackRan) return;
        callbackRan = true;
        markAdsDelivered();
      }
      try {
        window.gtag('event', 'conversion', {
          send_to: GOOGLE_SEND_TO,
          value: LEAD_VALUE,
          currency: 'USD',
          transaction_id: eventId,
          event_callback: acknowledge,
          event_timeout: GOOGLE_ACK_TIMEOUT_MS
        });
      } catch (_error) {
        state.adsInFlight = false;
        scheduleRetry();
        return;
      }
      if (!callbackRan) {
        state.adsAckTimer = window.setTimeout(function () {
          state.adsAckTimer = null;
          if (state.adsTerminal) return;
          state.adsInFlight = false;
          scheduleRetry();
        }, GOOGLE_ACK_TIMEOUT_MS);
      }
    }

    function attemptDelivery() {
      state.retryTimer = null;
      if (state.settled) return;
      state.attempts += 1;

      var marketingAllowed = processingPermission('marketingAllowed');
      var analyticsAllowed = processingPermission('analyticsProcessingAllowed');
      if (!state.adsTerminal) {
        if (marketingAllowed === false) markAdsConsentSkipped();
        else if (marketingAllowed === true) sendGoogleConversion();
      }
      if (!state.analyticsTerminal) {
        if (analyticsAllowed === false) markAnalyticsConsentSkipped();
        else if (analyticsAllowed === true) publishAnalyticsSuccess();
      }
      if (!finishIfSettled()) scheduleRetry();
    }

    state.wake = function () {
      if (state.settled) return;
      if (state.retryTimer !== null) {
        window.clearTimeout(state.retryTimer);
        state.retryTimer = null;
      }
      state.attempts = 0;
      attemptDelivery();
    };
    attemptDelivery();
    return true;
  }

  function init(scope) {
    var root = scope && scope.matches && scope.matches('[data-sr2-root]')
      ? scope
      : (scope || document).querySelector('[data-sr2-root]');
    if (!root) root = (scope || document).querySelector('.sr2-root');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    if (!trackSuccess(root, params)) prepareForm(root.querySelector('form'), params);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('visitorConsentCollected', wakeDeliveryStates);
})();
